
import { Component, Mixins } from 'vue-property-decorator';
import { VueClass } from 'vue-class-component/lib/declarations';
import { AxVuetify } from '@/mixins';

import * as V from 'vuetify/lib';

const Base = V.VTextField as VueClass<unknown>;

@Component
export default class VTextField extends Mixins(Base, AxVuetify) {
  async created() {
    Object.defineProperty(this, 'classes', {
      get: () => {
        return {
          ...this.baseClasses
        };
      }
    });

    await this.$nextTick();
    const input = this.$refs.input as HTMLInputElement;
    if (input.getAttribute('type') === 'password') {
      input.setAttribute('autocomplete', `new-password`);
    } else {
      input.setAttribute('autocomplete', `off`);
    }
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'none');
    input.setAttribute('spellcheck', 'false');
  }
}
